import BigNumber from 'bignumber.js';
import currencyFormatter from 'currency-formatter';
import { getCountryCode, getCurrencyCode } from 'utils/locale';

const intlNumberFormatCurrency = () => {
  const countryCode = getCountryCode() || 'de-DE';
  const currencyCode = getCurrencyCode() || 'EUR';

  const currencyFormatNumber = new Intl.NumberFormat(countryCode, {
    style: 'currency',
    currency: currencyCode,
  });

  return currencyFormatNumber;
};

const intlNumberFormatCurrencyNoSign = () => {
  const countryCode = getCountryCode() || 'de-DE';
  const currencyCode = getCurrencyCode() || 'EUR';
  const currencyFormatNumber = new Intl.NumberFormat(countryCode, {
    style: 'decimal',
    currency: currencyCode,
    useGrouping: true,
    minimumFractionDigits: 2,
  });
  return currencyFormatNumber;
};

export const intlDecimalFormat = () => {
  const countryCode = getCountryCode() || 'de-DE';
  const currencyCode = getCurrencyCode() || 'EUR';
  const decimalFormat = new Intl.NumberFormat(countryCode, {
    style: 'decimal',
    currency: currencyCode,
    useGrouping: false,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return decimalFormat;
};

const intlDefaultFormat = () => {
  const defualtNumberFormat = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    currency: 'USD',
    useGrouping: false,
    maximumFractionDigits: 2,
  });
  return defualtNumberFormat;
};

const currencyFormat = (value) => {
  const num = Number(value);
  return intlNumberFormatCurrency().format(num);
};

const currencyOptFormat = (value) => {
  const num = Number(value);
  return intlNumberFormatCurrency().format(num);
};

const percentFormat = (value) => {
  const num = Number(value);
  return intlDecimalFormat().format(num);
};

const formatNoSymbol = (value) => {
  const num = Number(value);
  return intlDecimalFormat().format(num);
};

const multiply = (number, time) => {
  return BigNumber(number).times(time).toNumber();
};

const plus = (number, time) => {
  return BigNumber(number).plus(time).toNumber();
};

const divide = (number, time) => {
  return BigNumber(number).dividedBy(time).toNumber();
};

const roundUpNumber = (number, time) => {
  const num = BigNumber(number).dp(time, 0);
  return BigNumber(num).toNumber();
};

const formatPrice = (value) => {
  const currencyCode = getCurrencyCode();
  if (!value) return;
  const replaceValue = value.replace(/[^a-zA-Z0-9]/g, '');
  const num = currencyFormatter.unformat(replaceValue, {
    code: currencyCode?.toUpperCase(),
    locale: getCountryCode(),
  });
  const newValue = multiply(num, 0.01);
  return intlNumberFormatCurrencyNoSign().format(newValue);
};

const formatTip = (value) => {
  if (!value) return;

  const currencyCode = getCurrencyCode();
  const number = value.replace(/[^0-9]/g, '');
  const num = currencyFormatter.unformat(number, {
    code: currencyCode.toUpperCase(),
  });

  if (num > 100) return 100;
  return num;
};

const currencySymbols = () => {
  const countryCode = getCountryCode() || 'de-DE';
  const currencyCode = getCurrencyCode() || 'EUR';
  const symbol = (0)
    .toLocaleString(countryCode, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim();
  return symbol;
};

const roundAndFixedNumber = (number) => {
  const data = BigNumber(number).toFixed(2);
  return BigNumber(data).toNumber();
};

const convertNumber = (value) => {
  const num = convertCurrencyToNumber(value);
  const number = Number(num);
  return intlDefaultFormat().format(number);
};

const convertCurrencyToNumber = (value) => {
  const countryCode = getCountryCode() || 'de-DE';
  var group = new Intl.NumberFormat(countryCode).format(1111).replace(/1/g, '');
  var decimal = new Intl.NumberFormat(countryCode).format(1.1).replace(/1/g, '');
  var reversedVal = value.replace(new RegExp('\\' + group, 'g'), '');
  reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
  return Number.isNaN(reversedVal) ? 0 : reversedVal;
};

const convertNumberToCurrency = (value) => {
  const currencyCode = getCurrencyCode() || 'EUR';
  if (!value) return;
  const replaceValue = value.toString().replace(/[A-Za-z]/g, '');
  const replaceComma = replaceValue.toString().replace('.', ',');
  return currencyCode === 'EUR' ? replaceComma : replaceValue;
};

export {
  currencyFormat,
  formatPrice,
  formatTip,
  currencyOptFormat,
  percentFormat,
  currencySymbols,
  convertNumber,
  formatNoSymbol,
  convertCurrencyToNumber,
  convertNumberToCurrency,
  plus,
  multiply,
  divide,
  roundUpNumber,
  roundAndFixedNumber,
};
